<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VBtn } from 'vuetify/lib';

export default defineComponent({
  name: 'MBtn',
  components: {
    VBtn,
  },
  inheritAttrs: false,
  props: {
    main: Boolean
  },
  computed: {
    actualColor(): string {
      return this.main ? 'secondary' : this.$attrs.color;
    },
    isIcon(): boolean {
      return !!this.$attrs.icon;
    },
  }
});
</script>

<template>
  <VBtn
    :outlined="!actualColor && !isIcon"
    :class="['text-none', { rounded: !isIcon }]"
    v-bind="$attrs"
    :color="actualColor"
    v-on="$listeners"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot
        :name="scopedSlotName"
        v-bind="slotData"
      />
    </template>
    <template
      v-for="(_, slotName) in $slots"
      #[slotName]
    >
      <slot :name="slotName" />
    </template>
  </VBtn>
</template>
